function capitalizeFirstLetter(string: string, locale: string | string[] | undefined = "nl"): string
{
	return string[ 0 ].toLocaleUpperCase(locale) + string.slice(1);
}

export default capitalizeFirstLetter;
